import shipmentSlice from './reducer'

export default shipmentSlice.reducer
